/**
 * Which extensions each FILE-VALUED element setting accepts.
 *
 * Mirrors `SETTING_FILE_TYPES` in the API, which **enforces** it — this half only keeps the picker from offering
 * a file the server would 422. Offering an image for a `Video` setting (or a model for `Image`) attaches
 * something Unity cannot load, and it fails silently in AR rather than loudly here.
 *
 * Lifted out of `ManualEditor.tsx` when the WebGL panel grew its own picker (ADR-044 §10 D15): two pickers
 * against one server rule need one list, and a page component is the wrong place for a panel to import from.
 */
export const MODEL_TYPES = [".glb", ".gltf", ".obj", ".fbx"];

export const SETTING_FILE_TYPES: Record<string, string[]> = {
  MeshObject: MODEL_TYPES,
  XRCModel: MODEL_TYPES,
  XRCModelAndroid: MODEL_TYPES,
  XRCModelIOS: MODEL_TYPES,
  Image: [".jpg", ".jpeg", ".png", ".svg", ".gif", ".webp"],
  Video: [".mp4", ".mov", ".m4v", ".webm"],
  TrainerVideos: [".mp4", ".mov", ".m4v", ".webm"],
  // The completed / failed state's own image OR video (ADR-027 §11 B) — attached to the state text setting itself.
  Interaction_CompletedText: [".jpg", ".jpeg", ".png", ".svg", ".gif", ".webp", ".mp4", ".mov", ".m4v", ".webm"],
  Interaction_FailedText: [".jpg", ".jpeg", ".png", ".svg", ".gif", ".webp", ".mp4", ".mov", ".m4v", ".webm"],
};
